import globalPageStyle from '../css/globalPage.module.scss';
import { useAuth } from '../context/AuthContext';
import styles from '../css/syncPage.module.scss';
import { EnvPaths } from '../helpers/environment';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useEffect, useRef, useState } from 'react';
import { PlanInterface } from '../helpers/objects/planObject';
const SyncPlansPage = () => {
  const { user } = useAuth();
  const ignoreRef = useRef(false);
  const [syncNeeded, setSyncNeeded] = useState(false);

  useEffect(() => {
    if (ignoreRef.current) return;

    const controller = new AbortController();
    checkSyncNeed();

    return () => {
      ignoreRef.current = true;
      controller.abort();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkSyncNeed = async () => {
    const localResponse = await getLocalPlans();
    const skycopResponse = await getSkycopPlans();
    if (localResponse?.error) {
      toast.error('Error getting local plans, contact system administrator urgently!');
    } else {
      if (skycopResponse?.error) {
        toast.error('Error getting skycop plans, contact system administrator urgently!');
      } else {
        if (skycopResponse.length !== localResponse.length) {
          toast.info('Local plans are not up to date, please sync plans');
          setSyncNeeded(true);
          return;
        }
      }
      if (localResponse.length === 0) {
        toast.info('Local plans are empty, please sync plans');
        setSyncNeeded(true);
      } else {
        const missingInfoCount = checkEveryPlanForStripeID(localResponse);
        if (missingInfoCount > 0) {
          toast.info('Some plans are missing stripe product ID, please sync plans');
          setSyncNeeded(true);
        } else {
          toast.info('All plans are up to date in the database and they include Stripe IDs');
        }
      }
    }
  };

  const checkEveryPlanForStripeID = (plan: PlanInterface[]) => {
    let missingInfoCount = 0;

    plan.forEach((plan) => {
      if (plan.stripeProductId === '' || plan.stripePriceId === '' || plan.stripeProductId === undefined || plan.stripePriceId === undefined) {
        missingInfoCount++;
      }
    });
    return missingInfoCount;
  };

  const getLocalPlans = async () => {
    try {
      const databasePlans = await axios.get(EnvPaths.SERVER_URL + '/skycop/get-local-product-list');
      return databasePlans.data;
    } catch (error) {
      console.error(error);
      return { error: error };
    }
  };

  const getSkycopPlans = async () => {
    try {
      const databasePlans = await axios.get(EnvPaths.SERVER_URL + '/skycop/get-skycop-product-list');
      return databasePlans.data;
    } catch (error) {
      console.error(error);
      return { error: error };
    }
  };

  const handleSyncPlans = async () => {
    try {
      toast.loading('Syncing plans...');
      const databasePlans = await axios.get(EnvPaths.SERVER_URL + '/skycop/get-local-product-list');
      let planSyncResponse = {
        status: 999,
      };

      if (databasePlans.data.length === 0) {
        planSyncResponse = await axios.get(EnvPaths.SERVER_URL + '/skycop/force-update-skycop-product-list');
      }
      if (planSyncResponse.status === 999 || planSyncResponse.status === 200) {
        toast.dismiss();
        toast.success('Skycop plans synced successfully');

        try {
          toast.loading('Syncing plans with stripe...');
          const stripeResponse = await axios.get(EnvPaths.SERVER_URL + '/plans/sync-stripe-with-database');
          if (stripeResponse.status === 200) {
            toast.dismiss();
            toast.success('Stripe plans synced successfully');
          }
        } catch (error) {
          toast.dismiss();
          toast.error('Error syncing plans with stripe.');
        }
      }
    } catch (err) {
      console.error(err);
      toast.dismiss();
      toast.error('Error syncing plans');
    }
  };

  return (
    <main className={globalPageStyle.pageContainer}>
      <div className={globalPageStyle.pageContent}>
        {user && user?.role === 'admin' ? (
          <div className={styles.logsContainer} style={{ textAlign: 'center' }}>
            <h1>Sync Plans</h1>
            <h2>(Use this only if needed)</h2>
            {syncNeeded ? (
              <button
                className="primaryButton"
                onClick={() => {
                  handleSyncPlans();
                }}
              >
                Sync Plans
              </button>
            ) : (
              <p>No sync is needed</p>
            )}
          </div>
        ) : (
          <h1>You do not have permission to view this page</h1>
        )}
      </div>
    </main>
  );
};

export default SyncPlansPage;
